import {
  ExportCarePlanData,
  ExportCarePlanReportData,
  ExportCarePlanTableData,
} from './export-care-plan-types';

/** For debugging purposes: Logs the raw data and returns a simplified version for easier inspection. */
export function exportCarePlanDebugData(
  reportData: ExportCarePlanReportData,
  exportData: ExportCarePlanData,
  tableData: ExportCarePlanTableData
) {
  console.group('Exporting Data');
  console.groupCollapsed('Raw Data');
  console.log('Group:', reportData.groupData);
  console.log('Group Details:', reportData.groupDetailsData);
  console.log('Group Activities Types:', reportData.groupActivitiesTypesData);
  console.log('User Care Plan:', reportData.userCarePlanData);
  console.log('User Group:', reportData.userGroupData);
  console.log('User Group Activity Types:', reportData.userActivityTypesData);
  console.log('User Group Details:', reportData.userGroupDetailsData);
  console.groupEnd();
  console.log('Grupo:', exportData.group);
  console.log('Detalhes:', exportData.details);
  console.log('Tarefas:', exportData.tasks);
  console.log('Tabela(s):', tableData);
  console.groupEnd();
}
